export default "__VITE_ASSET__Ddd1GlgL__"